import { Box } from '@mui/material'
import { useContext } from 'react'

import { AppContext } from '../../providers/AppProvider/AppProvider'
import { CurrentTimeClockCardContent } from './CurrentTimeClockCardContent'
import { NewTimeClockCardContent } from './NewTimeClockCardContent'
import { SlideInCard } from './SlideInCard'

export const DviTimeClockProductivityCard = ({
  employeeId
}: {
  employeeId: string
}) => {
  const { openTimeClockWithRelated, latestClosedTimeClockWithRelated } =
    useContext(AppContext)

  const showOpenTimeClock = !!openTimeClockWithRelated

  return (
    <Box m={1} sx={{ maxWidth: 1200 }}>
      <SlideInCard isIn={showOpenTimeClock}>
        {showOpenTimeClock && (
          <CurrentTimeClockCardContent timeClock={openTimeClockWithRelated} />
        )}
      </SlideInCard>
      <SlideInCard isIn={!showOpenTimeClock}>
        <NewTimeClockCardContent
          latestTimeClock={latestClosedTimeClockWithRelated}
          {...{ employeeId }}
          showChip={true}
        />
      </SlideInCard>
    </Box>
  )
}
